import React, { useEffect, useState } from "react";
import "./Thing.css";
import { useTheme } from "../theme/ThemeContext";
import DataTable from "react-data-table-component";
import { GiGate } from "react-icons/gi";
import { TbCarFanFilled } from "react-icons/tb";
import LoadingSpinner from '../Loading/LoadingSpinner'; // Make sure to import this
import NotificationPopup from '../alertpopup/NotificationPopup'; // Make sure to import this

const Thing = () => {
    const token = localStorage.getItem('authToken')

    const backendurl = window.location.hostname === 'localhost'
        ? ''
        : window.location.hostname === 'demo.ollinwon.com'
            ? process.env.REACT_APP_BACKEND_URL
            : window.location.hostname === 'iot.aizoteq.com'
                ? process.env.REACT_APP_BACKEND_URL2
                : '';

    const { theme } = useTheme();

    // Security Key Component
    const SecurityKeyCell = ({ securityKey }) => {
        const [isVisible, setIsVisible] = useState(false);

        return (
            <div
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                style={{ cursor: "pointer" }}
            >
                {isVisible ? securityKey : "**********"}
            </div>
        );
    };

    // State declarations
    const [showPopup, setShowPopup] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showSlide, setShowSlide] = useState(false);
    const [thingsData, setThingsData] = useState([]);
    const [mainLoading, setMainLoading] = useState(true);
    const [auditLoading, setAuditLoading] = useState(false);
    const [featureLoading, setFeatureLoading] = useState(false);
    const [error, setError] = useState(null);
    const [fetchUrl, setFetchUrl] = useState(`${backendurl}/dashboard/api/searchThings/working/instock/status/new`);
    const [searchTerm, setSearchTerm] = useState("");
    const [featurepopup, setfeaturepopup] = useState(false)
    const [mainImage, setMainImage] = useState()
    const [features, setFeatures] = useState([]);
    const [images, setImages] = useState([]);
    const [auditpopup, setAuditPopup] = useState(false)
    const [dataaa, setDataaa] = useState([]);
    const [columns, setColumns] = useState([]);
    const [devices, setDevices] = useState([]);
    const [selectedStock, setSelectedStock] = useState("In stock");
    const [selectedParty, setSelectedParty] = useState('');
    const [filterType, setFilterType] = useState("new");
    const [isStockDropdownVisible, setIsStockDropdownVisible] = useState(false);
    const [wifiData, setWifiData] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState("Customers");
    const [isCategoryDropdownVisible, setIsCategoryDropdownVisible] = useState(false);
    const [auditDetails, setAuditDetails] = useState([])
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [refreshText, setRefreshText] = useState("Refreshing");

    // Notification state
    const [notification, setNotification] = useState({
        show: false,
        type: "success",
        message: "",
        title: ""
    });

    // Notification helper function
    const showNotification = (type, message, title = "", duration = 3000) => {
        setNotification({
            show: true,
            type,
            message,
            title
        });

        setTimeout(() => {
            setNotification(prev => ({ ...prev, show: false }));
        }, duration);
    };

    const getIconClass = (deviceType) => {
        const iconMap = {
            light: <i className="fa-solid fa-lightbulb"></i>,
            fan: <TbCarFanFilled />,
            socket: <i className="fa-solid fa-plug"></i>,
            curtain: <i className="fa-solid fa-person-booth"></i>,
            gate: <GiGate />,
            trm: <i className="fa-solid fa-temperature-low"></i>,
            bell: <i className="fa-solid fa-bell"></i>,
        };
        return iconMap[deviceType] || <i className="fa-solid fa-question"></i>;
    };

    const toggleStockDropdown = () => {
        setIsStockDropdownVisible(!isStockDropdownVisible);
    };

    const toggleCategoryDropdown = () => {
        setIsCategoryDropdownVisible(!isCategoryDropdownVisible);
    };

    const handleStockItemClick = (item) => {
        const newFetchUrl = `${backendurl}/dashboard/api/searchThings/working/${item}/status/new`;
        setFetchUrl(newFetchUrl);
        setSelectedStock(item);
        setIsStockDropdownVisible(false);

        // Show notification
        if (item === "sold") {
            setIsCategoryDropdownVisible(true);
            showNotification("info", "Select customer type", "Filter Changed");
        } else {
            setIsCategoryDropdownVisible(false);
            showNotification("info", `Showing ${item} items`, "Filter Changed");
        }
    };

    const handleCategoryItemClick = (item, name) => {
        setSelectedParty(item);
        setSelectedCategory(name);
        setIsCategoryDropdownVisible(false);
        handleFilterChange(filterType, item);
        showNotification("info", `Showing ${name} data`, "Category Changed");
    };

    const handleImageClick = (image) => {
        setMainImage(image);
    };

    const handleAuditPopupclose = () => {
        setWifiData(null);
        setAuditPopup(false);
    }

    const handleAuditRefresh = async () => {
        setIsRefreshing(true);
        setRefreshText("Refreshing");
        let count = 0;

        const interval = setInterval(() => {
            count = (count + 1) % 4;
            setRefreshText(`Refreshing${".".repeat(count)}`);
        }, 500);

        try {
            await handleAuditPopup(auditDetails);
            showNotification("success", "Audit data refreshed", "Success");
        } catch (error) {
            showNotification("error", "Failed to refresh audit data", "Error");
        } finally {
            clearInterval(interval);
            setIsRefreshing(false);
            setRefreshText("Refreshing");
        }
    };

    const handleAuditPopup = async (thing) => {
        setAuditPopup(true);
        setAuditDetails(thing);
        setAuditLoading(true);
        setError(null);

        try {
            // Fetch device details
            const deviceResponse = await fetch(`${backendurl}/api/devices/things/${thing.thing_id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!deviceResponse.ok) {
                throw new Error("Failed to fetch devices");
            }

            const deviceData = await deviceResponse.json();
            setDevices(deviceData);
            showNotification("success", "Device data loaded", "Success");

            // Fetch Wi-Fi data
            await fetchWifiData(thing.macaddress);

            // Fetch audit log data
            const auditLogResponse = await fetch(`${backendurl}/dashboard/api/display/auditlog/${thing.macaddress}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!auditLogResponse.ok) {
                throw new Error(`Failed to fetch audit log: ${auditLogResponse.status}`);
            }

            const auditLogData = await auditLogResponse.json();

            if (!auditLogData.events || auditLogData.events.length === 0) {
                showNotification("info", "No audit log events found", "No Data");
            } else {
                showNotification("success", `Loaded ${auditLogData.events.length} audit events`, "Success");
            }

            setDataaa(auditLogData.events || []);

        } catch (error) {
            console.error("Error fetching data:", error);
            setError(error.message);
            showNotification("error", error.message || "Failed to load audit data", "Error");
        } finally {
            setAuditLoading(false);
            setIsRefreshing(false);
        }
    };

    const fetchWifiData = async (thingmac) => {
        try {
            const response = await fetch(`${backendurl}/dashboard/api/device/wifi/status/${thingmac}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                throw new Error('Failed to fetch Wi-Fi data');
            }

            const data = await response.json();
            setWifiData(data.wifiData);

        } catch (error) {
            console.error('Error fetching Wi-Fi data:', error);
            showNotification("warning", "Could not load Wi-Fi status", "Connection Error");
        }
    };

    const handelFeaturepopup = (row) => {
        setFeatureLoading(true);
        fetchModelData(row.model);
        setEditData(row);
        setfeaturepopup(true);
    }

    const fetchModelData = async (modelId) => {
        setFeatureLoading(true);
        try {
            const response = await fetch(`${backendurl}/dashboard/api/things/features/${modelId}`);

            if (!response.ok) {
                throw new Error("Failed to fetch model data");
            }

            const data = await response.json();

            if (!data.features || data.features.length === 0) {
                showNotification("info", "No features found for this model", "No Data");
            } else {
                showNotification("success", `Loaded ${data.features.length} features`, "Success");
            }

            setFeatures(data.features || []);
            setImages(data.images || []);
            setMainImage(data.images?.[0] || null);

        } catch (error) {
            console.error("Error fetching model data:", error);
            showNotification("error", error.message || "Failed to load model features", "Error");
        } finally {
            setFeatureLoading(false);
        }
    };

    const handleEdit = (row) => {
        setEditData(row);
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setEditData(null);
    };

    const handleSlide = () => {
        setShowSlide((prev) => !prev);
    };

    useEffect(() => {
        fetchThingsData(fetchUrl);
    }, [fetchUrl]);

    const fetchThingsData = async (url) => {
        setMainLoading(true);
        setError(null);

        try {
            const response = await fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });

            // 🔹 Handle specific status codes
            if (response.status === 404) {
                const message = `No things found for ${selectedStock}${selectedStock === "sold" ? ` in ${selectedCategory}` : ""
                    }`;

                setThingsData([]);
                generateColumns([]);

                showNotification("info", message, "No Data");
                return; // ⛔ stop further execution
            }

            if (!response.ok) {
                throw new Error(`Failed to fetch things data: ${response.statusText}`);
            }

            const data = await response.json();
            const items = Array.isArray(data) ? data : [];

            if (items.length === 0) {
                const message = `No things found for ${selectedStock}${selectedStock === "sold" ? ` in ${selectedCategory}` : ""
                    }`;
                showNotification("info", message, "No Data");
            } else {
                showNotification("success", `Loaded ${items.length} items`, "Success");
            }

            setThingsData(items);
            generateColumns(items);

        } catch (err) {
            console.error(err);
            setError(err.message);

            showNotification(
                "error",
                err.message || "Error loading data",
                "Error Loading Data"
            );

        } finally {
            setMainLoading(false);
        }
    };


    const handleFilterChange = (filterType, selectedParty) => {
        setFilterType(filterType);
        let newUrl = `${backendurl}/dashboard/api/searchThings/working/${selectedStock}/status/${filterType}`;

        if (selectedStock === "sold" && selectedParty) {
            newUrl += `?party=${selectedParty}`;
        }

        setFetchUrl(newUrl);
        showNotification("info", `Filter set to: ${filterType}`, "Filter Applied");
    };

    const handleSearchChange = (e) => {
        const newSearchTerm = e.target.value;
        setSearchTerm(newSearchTerm);
        setError(null);

        let newUrl = `${backendurl}/dashboard/api/searchThings/working/${selectedStock}/status/${filterType}`;
        let queryParams = [];

        if (selectedStock === "sold" && selectedParty) {
            queryParams.push(`party=${encodeURIComponent(selectedParty)}`);
        }

        if (selectedStock === "instock" && newSearchTerm) {
            queryParams.push(`serialno=${encodeURIComponent(newSearchTerm)}`);
        } else if (selectedStock !== "instock" && newSearchTerm) {
            queryParams.push(`searchTerm=${encodeURIComponent(newSearchTerm)}`);
        }

        if (queryParams.length > 0) {
            newUrl += `?${queryParams.join("&")}`;
        }

        setFetchUrl(newUrl);

        if (newSearchTerm) {
            showNotification("info", `Searching for: ${newSearchTerm}`, "Searching...");
        }
    };

    const columns1 = [
        { name: "Switch", selector: (row) => row.switchName || "null", sortable: true },
        { name: "State", selector: (row) => row.state || "null", sortable: true },
        {
            name: "Date",
            selector: (row) =>
                row.time ? new Date(row.time).toLocaleDateString() : "null",
            sortable: true,
        },
        {
            name: "Time",
            selector: (row) =>
                row.time ? new Date(row.time).toLocaleTimeString() : "null",
            sortable: true,
        },
        { name: "Method", selector: (row) => row.method || "null", sortable: true },
        { name: "Type", selector: (row) => row.type || "null", sortable: true },
    ];

    const generateColumns = (data) => {
        let featureColumns = new Set();
        let attributeColumns = new Set();

        data.forEach((thing) => {
            if (thing.features) {
                thing.features.forEach((feature) => feature.feature && featureColumns.add(feature.feature));
            }
            if (thing.attributes) {
                thing.attributes.forEach((attribute) => attribute.attributeName && attributeColumns.add(attribute.attributeName));
            }
        });

        const columns = [
            {
                name: 'ID',
                selector: (row, index) => index + 1,
                sortable: true
            },
            { name: "Thing Name", selector: (row) => row.thingname || "null", sortable: true },
            { name: "Created By", selector: (row) => row.createdby || "null", sortable: true },
            { name: "Batch ID", selector: (row) => row.batchid || "null", sortable: true },
            { name: "Model", selector: (row) => row.model || "null", sortable: true },
            { name: "Mac Address", selector: (row) => row.macaddress || "null", sortable: true },
            { name: "Serial No", selector: (row) => row.serialno || "null", sortable: true },
            {
                name: "Security Key",
                cell: (row) => <SecurityKeyCell securityKey={row.securitykey} />,
                sortable: true,
            },
            { name: "Status", selector: (row) => row.status || "null", sortable: true },
            {
                name: "Added Date",
                selector: (row) => {
                    const dateString = row.addedat ? row.addedat.split('T')[0] : "null";
                    return dateString;
                },
                sortable: true
            },
            {
                name: "Added Time",
                selector: (row) => {
                    const timeString = row.addedat ? row.addedat.split('T')[1]?.split('.')[0] : "null";
                    return timeString;
                },
                sortable: true
            },
            { name: "Added By", selector: (row) => row.addedby || "null", sortable: true },
            { name: "user_name", selector: (row) => row.user_name || "null", sortable: true },
            { name: "user_phone", selector: (row) => row.user_phone || "null", sortable: true },
            { name: "Failure Reason", selector: (row) => row.failureReason || "null", sortable: true },
            { name: "Fixed By", selector: (row) => row.fixed_by || "null", sortable: true },
            { name: "Logged At", selector: (row) => row.loggedAt || "null", sortable: true },
        ];

        // Add dynamic feature columns
        featureColumns.forEach((feature) => {
            columns.push({
                name: feature,
                selector: (row) => {
                    const featureObj = row.features?.find((f) => f.feature === feature);
                    return featureObj ? featureObj.feature_value || "-" : "-";
                },
                sortable: true,
            });
        });

        // Add dynamic attribute columns
        attributeColumns.forEach((attribute) => {
            columns.push({
                name: attribute,
                selector: (row) => {
                    const attributeObj = row.attributes?.find((a) => a.attributeName === attribute);
                    return attributeObj ? attributeObj.attributeValue || "-" : "-";
                },
                sortable: true,
            });
        });

        const actionColumns = [
            {
                name: "Audit Log",
                cell: (row) => (
                    <button className="test-button" onClick={() => handleAuditPopup(row)} disabled={auditLoading}>
                        {auditLoading ? (
                            <LoadingSpinner size="small" color={theme === 'dark' ? 'white' : 'dark'} />
                        ) : (
                            <i className="fa-regular fa-file"></i>
                        )}
                    </button>
                ),
            },
        ];

        const finalColumns = [...columns, ...actionColumns];
        setColumns(finalColumns);
    };

    // No Data Component
    const NoDataComponent = () => (
        <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            color: theme === 'dark' ? '#ccc' : '#666'
        }}>
            <i className="fa-solid fa-box" style={{ fontSize: '48px', marginBottom: '20px', opacity: 0.5 }}></i>
            <h3>No Things Found</h3>
            <p>
                {searchTerm
                    ? `No items found for "${searchTerm}"`
                    : `No ${selectedStock} items found${selectedStock === "sold" ? ` for ${selectedCategory}` : ''}`
                }
            </p>
        </div>
    );

    return (
        <div className={`thing-main ${theme}-theme`}>
            {/* Notification Popup */}
            <NotificationPopup
                show={notification.show}
                type={notification.type}
                message={notification.message}
                title={notification.title}
                onClose={() => setNotification({ ...notification, show: false })}
                duration={5000}
            />

            <div className="dash-dummy"></div>
            <div className="second-main">
                <div className="thing-content-main">
                    <div className="thing-content">
                        <div className="thing-content-head">
                            <p>Thing Details</p>
                            {mainLoading && (
                                <span style={{
                                    marginLeft: '10px',
                                    fontSize: '0.9rem',
                                    color: theme === 'dark' ? '#3498db' : '#2980b9'
                                }}>
                                    {/* <LoadingSpinner size="small" color={theme === 'dark' ? 'primary' : 'primary'} /> */}
                                </span>
                            )}
                        </div>

                        <div className="thing-content-stock-deatails-main">
                            <div className="thing-content-stock-deatails">
                                <div
                                    className="thing-content-stock-product"
                                    onClick={toggleStockDropdown}
                                    style={{ cursor: "pointer" }}
                                >
                                    <p>{selectedStock}</p>
                                    <i className={`fa-solid ${isStockDropdownVisible ? "fa-angle-up" : "fa-angle-down"}`}></i>
                                </div>
                                {isStockDropdownVisible && (
                                    <div className="dropdown">
                                        <ul>
                                            <li onClick={() => handleStockItemClick("sold")}>Sold</li>
                                            <li onClick={() => handleStockItemClick("In Stock")}>In Stock</li>
                                        </ul>
                                    </div>
                                )}
                            </div>

                            {selectedStock === "sold" && (
                                <div className="thing-content-stock-deatails">
                                    <div
                                        className="thing-content-stock-product"
                                        onClick={toggleCategoryDropdown}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <p>{selectedCategory}</p>
                                        <i className={`fa-solid ${isCategoryDropdownVisible ? "fa-angle-up" : "fa-angle-down"}`}></i>
                                    </div>
                                    {isCategoryDropdownVisible && (
                                        <div className="dropdown">
                                            <ul>
                                                <li onClick={() => handleCategoryItemClick("customer", "Customers")}>Customers</li>
                                                <li onClick={() => handleCategoryItemClick("onlineCustomer", "Online Customers")}>Online Customers</li>
                                                <li onClick={() => handleCategoryItemClick("dealer", "Dealers")}>Dealers</li>
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="thing-content-items">
                            <div className="device-search">
                                <i className="fa-solid fa-magnifying-glass"></i>
                                <input
                                    type="search"
                                    placeholder="Search by Serial No..."
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    disabled={mainLoading}
                                />
                                {mainLoading && (
                                    <div style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                                        {/* <LoadingSpinner size="small" color={theme === 'dark' ? 'light' : 'dark'} /> */}
                                    </div>
                                )}
                            </div>

                            <div style={{ position: "relative" }}>
                                <i className="fa-solid fa-sliders" onClick={handleSlide}></i>
                                {showSlide && (
                                    <div className="thing-slide-menu show">
                                        {["rework", "new", "returned"].map(
                                            (filter) => (
                                                <div
                                                    key={filter}
                                                    className="thing-slide-item"
                                                    onClick={() => handleFilterChange(filter)}
                                                >
                                                    <span>{filter}</span>
                                                    {filterType === filter && (
                                                        <i className="fa-solid fa-check" style={{ marginLeft: '10px' }}></i>
                                                    )}
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {mainLoading ? (
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '400px',
                            width: '100%'
                        }}>
                            <LoadingSpinner
                                size="large"
                                text={`Loading ${selectedStock} items...`}
                                color={theme === 'dark' ? 'primary' : 'primary'}
                            />
                        </div>
                    ) : error ? (
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '400px',
                            color: theme === 'dark' ? '#e74c3c' : '#c0392b'
                        }}>
                            <i className="fa-solid fa-triangle-exclamation" style={{ fontSize: '48px', marginBottom: '20px' }}></i>
                            <h3>Error Loading Data</h3>
                            <p>{error}</p>
                            <button
                                onClick={() => fetchThingsData(fetchUrl)}
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    backgroundColor: theme === 'dark' ? '#3498db' : '#2980b9',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                                Retry
                            </button>
                        </div>
                    ) : thingsData.length === 0 ? (
                        <NoDataComponent />
                    ) : (
                        <DataTable
                            columns={columns}
                            data={thingsData}
                            fixedHeader
                            pagination
                            noDataComponent={<NoDataComponent />}
                        />
                    )}

                    {featurepopup && (
                        <div className="feature-popup-overlay">
                            <div className="feature-popup-content-main">
                                <button
                                    className="model-popup-close"
                                    onClick={() => setfeaturepopup(false)}
                                >
                                    <i className="fa-solid fa-x"></i>
                                </button>

                                {featureLoading ? (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '400px',
                                        width: '100%'
                                    }}>
                                        <LoadingSpinner
                                            size="medium"
                                            text="Loading features..."
                                            color={theme === 'dark' ? 'primary' : 'primary'}
                                        />
                                    </div>
                                ) : (
                                    <div className="feature-popup-content">
                                        <div className="feature-popup-image-main">
                                            {images.length > 0 ? (
                                                <>
                                                    <div className="feature-popup-image">
                                                        <img src={`${backendurl}${mainImage}`} alt="Main" />
                                                    </div>
                                                    <div className="feature-popup-subimg-main">
                                                        {images.map((img, index) => (
                                                            <img
                                                                key={index}
                                                                src={`${backendurl}${img}`}
                                                                alt={`Sub ${index + 1}`}
                                                                onClick={() => handleImageClick(img)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        ))}
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '200px',
                                                    color: theme === 'dark' ? '#ccc' : '#666'
                                                }}>
                                                    <p>No images available</p>
                                                </div>
                                            )}
                                        </div>
                                        <div className="feature-popup-list-main">
                                            {features.length > 0 ? (
                                                <ul>
                                                    {features.map((feature, index) => (
                                                        <li key={index}>{feature}</li>
                                                    ))}
                                                </ul>
                                            ) : (
                                                <div style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '200px',
                                                    color: theme === 'dark' ? '#ccc' : '#666'
                                                }}>
                                                    <p>No features available</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                    {auditpopup && (
                        <div className="audit-popup-overlay">
                            <div className="audit-popup-content-main">
                                <button className="model-popup-close" onClick={handleAuditPopupclose}>
                                    <i className="fa-solid fa-x"></i>
                                </button>

                                <div className="audit-popup-content">
                                    {auditLoading ? (
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '300px',
                                            width: '100%'
                                        }}>
                                            <LoadingSpinner
                                                size="medium"
                                                text="Loading audit data..."
                                                color={theme === 'dark' ? 'primary' : 'primary'}
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="audit-popup-btn-details">
                                                <div className="audit-popup-btn-main">
                                                    {devices.length > 0 ? (
                                                        devices.map((device, index) => {
                                                            const IconComponent = getIconClass(device.type);
                                                            return (
                                                                <button key={index}>
                                                                    {IconComponent}
                                                                </button>
                                                            );
                                                        })
                                                    ) : (
                                                        <p style={{ color: theme === 'dark' ? '#ccc' : '#666' }}>No devices found</p>
                                                    )}
                                                </div>
                                                <div className="audit-popup-wifi-main">
                                                    <div className="audit-popup-wifi-details">
                                                        <p>Connection:</p>
                                                        <p>{wifiData ? wifiData.connection : 'N/A'}</p>
                                                    </div>
                                                    <div className="audit-popup-wifi-details">
                                                        <p>Strength:</p>
                                                        <p>{wifiData ? wifiData.signalStrength : 'N/A'} , {wifiData ? wifiData.quality : 'N/A'}</p>
                                                    </div>
                                                    <div className="audit-popup-wifi-details">
                                                        <p>Wifi SSID:</p>
                                                        <p>{wifiData ? wifiData.wifiSSID : 'N/A'}</p>
                                                    </div>
                                                    <div className="audit-popup-wifi-details">
                                                        <p>Device Type:</p>
                                                        <p>{wifiData ? wifiData.deviceType : 'N/A'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="audit-popup-state-details">
                                                <div className="audit-popup-reload-btn" onClick={handleAuditRefresh}>
                                                    <i
                                                        className={`fa-solid fa-rotate-right ${isRefreshing ? "spin" : ""}`}
                                                    ></i>
                                                    <p>{refreshText}</p>
                                                </div>

                                                <div className="audit-popup-state-main">
                                                    {dataaa.length > 0 ? (
                                                        <DataTable
                                                            columns={columns1}
                                                            data={dataaa}
                                                            fixedHeader
                                                            pagination
                                                            noDataComponent={
                                                                <div style={{
                                                                    textAlign: 'center',
                                                                    padding: '20px',
                                                                    color: theme === 'dark' ? '#ccc' : '#666'
                                                                }}>
                                                                    No audit events found
                                                                </div>
                                                            }
                                                        />
                                                    ) : (
                                                        <div style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                            height: '200px',
                                                            color: theme === 'dark' ? '#ccc' : '#666'
                                                        }}>
                                                            <p>No audit events found</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Thing;